<template>
    <div>
        <title-header title="UGT-SP Notícias"></title-header>
        <div class="container">
            <div class="list-item" v-for="(comment, index) in comments" :key="index">
                <div class="image">
                    <img :src="getFirstActveImage(comment.imagens)" alt="Imagem">
                </div>
                <div class="content">
                    <header>
                        <h4>{{ comment.titulo }}</h4>
                        <p>
                            por <span>UGT-SP Notícias</span>, {{ comment.data_noticia }}
                        </p>
                    </header>
                    <div>
                        <p v-html="comment.noticia.substring(0,300)" v-if="comment.noticia.length > 0"></p>
                        <router-link :to="{path: 'noticia/'+ comment.id}" class="font-black italic text-black">
                            ...Leia mais
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="tabs">
            <button class="arrow" @click="previous"><</button>
            <button v-for="page in pages"
                    v-if="Math.abs(page - active) < 3 || page === lastPage || page === 1"
                    :key="page"
                    class="tab"
                    @click="onPageChange(page); active = page"
                    :class="{'bg-primary':page === active,
                    last: (page === lastPage && Math.abs(page - active) > 3),
                    first:(page === 1 && Math.abs(page - active) > 3)}"
                    >
                {{ page }}
            </button>
            <button class="arrow" @click="next">></button>
        </div>
    </div>
</template>

<script>
import TitleHeader from '../../../../components/title/title'

import axios from 'axios';
import imagesMixin from '../../../../mixins/images.mixin';

export default {
    name: "list-noticias",
    components: {
        TitleHeader,
    },
    mixins: [imagesMixin],
    data() {
        return {
            comments: [],
            pages: [],
            active: 1,
            lastPage: 0,
        };
    },
    methods: {
        getComments() {
            axios.get('get-ugt-noticias')
            .then(res => {
                const noticias = res.data.noticia.data.filter(noticia => {
                    return noticia.categoria === "1"
                })
                this.comments = noticias
                this.pages = res.data.noticia.last_page
                this.lastPage = res.data.noticia.last_page
            })
        },
        onPageChange(index) {
            axios.get('get-ugt-noticias?page=' + index)
            .then(res => {
                this.comments = res.data.noticia.data
                console.log(index)
            })
        },
        next() {
            if(this.active < this.lastPage) {
                this.onPageChange(this.active + 1)
                this.active += 1
            }
        },
        previous() {
            if(this.active > 1) {
                this.onPageChange(this.active - 1)
                this.active -= 1
            }
        }
    },
    created() {
        this.getComments()
    }
}
</script>

<style scoped lang="scss">
.container {
    max-width: 1280px;
    @apply px-8 mx-auto;
    .list-item {
        @apply border-light-gray border-b-2 py-6 flex items-start;
        @media(max-width: 414px) {
            @apply flex flex-col;
            header {
                @apply mt-4;
            }
        }
        @media(max-width: 768px) {
            @apply flex;
            header {
                @apply flex-col;
            }
            .image {
                @apply w-full;
            }
        }
        header {
            @apply flex justify-between mb-2;
            h4 {
                @apply font-medium text-xl;
            }
            span {
                @apply text-tertiary;
            }
        }
        p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            @apply text-sm;
        }
        .image {
            width: 200px;
            height: auto;
            @apply mr-10 rounded-lg bg-primary;
            img{
                @apply rounded-lg w-full;
                height: 140px;
            }
        }
        .content {
            @apply w-full;
        }
    }
}
.tabs {
    @apply mx-auto text-center my-12;
    .tab {
        @apply px-2 rounded-md mx-1 text-base-gray;
        border: 0.5px solid #8e8e8e;
        @media(min-width: 640px) {
            @apply rounded-lg mr-3 py-1 px-3 font-medium text-xl text-base-gray;
            border: 1px solid #8e8e8e;
        }
    }
    .tab:hover{
        @apply bg-primary font-medium text-white outline-none border-primary;
    }
    .tab:focus {
        @apply text-white outline-none;
    }
    .tab.first::after {
        content:'...'
    }

    .tab.last::before {
        content:'...'
    }
    .arrow {
        @apply py-1 font-medium text-base text-base-gray;
        @media(min-width: 640px) {
            @apply mr-3 py-1 px-3 font-medium text-xl text-base-gray;
        }
    }
    .arrow:focus {
        @apply outline-none;
    }
}
</style>
